module.exports = __webpack_public_path__ + "img/add1.b40b9913.svg";